import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Home,
    children: [],
  },
  {
    path: '/home',
    component: () => import('../views/homepage/Index.vue'),
    children: [
      {
        path: '/',
        name: 'name',
        component: () => import('../views/search/Search.vue')
      },
      {
        path: '/search',
        name: 'name',
        component: () => import('../views/search/Search.vue')
      },
      {
        path: '/information',
        component: () => import('../views/information/Index.vue')
      },
      {
        path: '/newscenter',
        component: () => import('../views/newscenter/Index.vue')
      },


      {
        path: '/resourcepro',
        component: () => import('../views/resourcepro/Index.vue'),
        children: [
          {
            path: '/',
            component: () => import('../views/resourcepro/conponent/Geosites.vue')
          },
          {
            path: '/resourcepro',
            component: () => import('../views/resourcepro/conponent/Geosites.vue')
          },
          {
            path: '/Eco-resources',
            component: () => import('../views/resourcepro/conponent/Eco-resources.vue')
          },
          {
            path: '/culturalHeritage',
            component: () => import('../views/resourcepro/conponent/culturalHeritage.vue')
          },
          {
            path: '/Statute',
            component: () => import('../views/resourcepro/conponent/Statute.vue')
          }
        ]
      },


      {
        path: '/teach',
        component: () => import('../views/teach/Index.vue'),
        children: [
          {
            path: '/',
            component: () => import('../views/teach/conponent/Scientific.vue')
          },
          {
            path: '/teach',
            component: () => import('../views/teach/conponent/Scientific.vue')
          },
          {
            path: '/Educational',
            component: () => import('../views/teach/conponent/Educational.vue')
          },
          {
            path: '/Publication',
            component: () => import('../views/teach/conponent/Publication.vue')
          }
        ]
      },
      {
        path: '/travel',
        component: () => import('../views/travel/Index.vue'),
        children: [
          {
            path: '/',
            component: () => import('../views/travel/Scenic.vue')
          },
          {
            path: '/travel',
            component: () => import('../views/travel/Scenic.vue')
          },
          {
            path: '/eat',
            component: () => import('../views/travel/Eat.vue')
          },
          {
            path: '/live',
            component: () => import('../views/travel/Live.vue')
          },
          {
            path: '/play',
            component: () => import('../views/travel/Play.vue')
          },
          {
            path: '/walk',
            component: () => import('../views/travel/Walk.vue')
          }
        ]
      },
      {
        path: '/sisterpark',
        component: () => import('../views/sisterpark/Index.vue'),
        children: [
          {
            path: '/',
            component: () => import('../views/sisterpark/conponent/sisterGeoparks.vue')
          },
          {
            path: '/sisterpark',
            component: () => import('../views/sisterpark/conponent/sisterGeoparks.vue')
          },
          {
            path: '/schools',
            component: () => import('../views/sisterpark/conponent/schools.vue')
          },
          {
            path: '/links',
            component: () => import('../views/sisterpark/conponent/links.vue')
          },
          {
            path: '/corporations',
            component: () => import('../views/sisterpark/conponent/corporations.vue')
          },
          {
            path: '/communities',
            component: () => import('../views/sisterpark/conponent/communities.vue')
          }
        ]
      },
      {
        path: '/download',
        component: () => import('../views/download/Index.vue'),
        children: [
          {
            path: '/',
            component: () => import('../views/download/conponent/image.vue')
          },
          {
            path: '/download',
            component: () => import('../views/download/conponent/image.vue')
          },
          {
            path: '/video',
            component: () => import('../views/download/conponent/video.vue')
          },
          {
            path: '/file',
            component: () => import('../views/download/conponent/file.vue')
          }
        ]
      },
      {
        path: '/detail',
        name: 'detail',
        component: () => import('../views/detail/Detail.vue')
      }
    ]
  },
]

const router = new VueRouter({
  // mode: 'history',
  routes
})

export default router
